module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.878ad71.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/roboto/Roboto-Regular.woff
// module id = byGT
// module chunks = 0